<template>
    <div class="small-collapse" id="Step2" v-if="product">

        <!-- Make a gift -->
		<div class="wwf-checkbox" v-if="product.producttype == 'adoption'">
			<label>Make this a gift for someone
				<input type="checkbox" id="isGift" name="isGift" v-model="donation.isGift">
				<span class="checkbox"></span>
			</label>
		</div>
        <!-- /Make a gift -->

    <!-- Wildcard-->
		<div class="small-collapse small-12 columns" v-if="product.producttype == 'wildcard'">
			<h2>Personalise your wildcard</h2>
      <div class="small-12 columns">
      <div class="wilcards--selected"><img :src="product.packages.find(x=>x.code == donation.packagecode) ? product.packages.find(x=>x.code == donation.packagecode).img : null" class="tooltipstered" /></div>
      </div>
      		<div class="small-12 columns">
		<div class="field" :class="donation.wildcard.dear ? 'has-content' : ''">
            <input name="dear" type="text" v-model="donation.wildcard.dear" v-validate="'required'" :class="{'border-red': errors.has('dear')}" placeholder="Enter the name">
			<label for="dear">Dear {{ errors.first('dear') ? 'required' : '' }}</label>    
		</div>
		</div>
    <div class="small-12 columns">
    <div class="field" :class="donation.wildcard.message ? 'has-content' : ''">
            <textarea name="message" type="text" v-model="donation.wildcard.message" v-validate="'required'" :class="{'border-red': errors.has('message')}" placeholder="Enter the message"></textarea>
			<label for="message">Your personal message {{ errors.first('message') ? 'required' : '' }}</label>
		</div>
    </div>
    <div class="small-12 columns">
    		<div class="field" :class="donation.wildcard.email ? 'has-content' : ''">
			<input type="email" name="recepientsemail" id="recepientsemail" v-model="donation.wildcard.email" v-validate="'required|email'" :class="{'border-red': errors.has('recepientsemail')}" placeholder="Email">
			<label for="recepientsemail">Recipients email {{ errors.firstByRule('recepientsemail', 'required') ? 'required' : '' }} {{ errors.firstByRule('recepientsemail', 'email') ? 'invalid' : '' }}</label>
		</div>
    </div>

    		<div class="small-12 columns">
          <h2>When do you want it sent?</h2>
			<!-- DESKTOP-->
		<div class="field" :class="donation.wildcard.scheduledate ? 'has-content' : ''">
		<datepicker :disabledDates="disabledFn" name="scheduledate" v-validate="'required'"  :minimumView="'day'" :format="'dd/MM/yyyy'" :input-class="{'border-red': errors.has('scheduledate')}" v-model="donation.wildcard.scheduledate" :maximumView="'month'" :initialView="'day'" placeholder="Enter your date"></datepicker>
			<label for="scheduledate">Choose a date {{ errors.first('scheduledate') ? 'required' : '' }} <i class="far fa-calendar-alt"></i></label>
		</div>
		</div>
    </div>
    <!-- /Wildcard -->
<div class="small-12 columns">
		<h2>Enter your details</h2>
        </div>
		<div class="wwf-checkbox">
			<label>This donation is on behalf of a business
				<input type="checkbox" id="isBehalfBusiness" name="isBehalfBusiness" v-model="donation.isBehalfBusiness">
				<span class="checkbox"></span>
			</label>
		</div>

		<div class="small-collapse small-12 columns field-businessname" v-if="donation.isBehalfBusiness">
			<div class="small-12 columns">
		<div class="field" :class="donation.bussiness.name ? 'has-content' : ''">
			<input name="businessName" type="text" v-model="donation.bussiness.name" v-validate="'required'" :class="{'border-red': errors.has('businessName')}" placeholder="Enter your business name" autocomplete="organization">
			<label for="businessName">Business name {{ errors.first('businessName') ? 'required' : '' }}</label>   
		</div>
			</div>
		</div>

		<div class="small-12 medium-6 columns left-field field-title">
		<div class="field" :class="donation.title ? 'has-content' : ''">
				 <select name="title" v-model="donation.title" v-validate="'required'" :class="{'border-red': errors.has('title')}" placeholder="Title" autocomplete="honorific-prefix">
					<option value="" disabled selected>Select a title</option>
					<option value="Mr">Mr</option>
					<option value="Mrs">Mrs</option>
					<option value="Ms">Ms</option>
					<option value="Miss">Miss</option>
				</select>
			<label for="title">Title {{ errors.first('title') ? 'required' : '' }}</label>
		</div>
		</div>

		<div class="small-12 medium-6 columns right-field field-firstname">
		<div class="field" :class="donation.firstname ? 'has-content' : ''">
            <input name="firstname" type="text" v-model="donation.firstname" v-validate="'required'" :class="{'border-red': errors.has('firstname')}" placeholder="Enter your first name" autocomplete="given-name">
			<label for="firstname">First name {{ errors.first('firstname') ? 'required' : '' }}</label>
		</div>
		</div>
		<div class="small-12 medium-6 columns left-field field-lastname">
		<div class="field" :class="donation.lastname ? 'has-content' : ''">
            <input name="lastname" type="text" v-model="donation.lastname" v-validate="'required'" :class="{'border-red': errors.has('lastname')}" placeholder="Enter your last name" autocomplete="family-name">
			<label for="lastname">Last name {{ errors.first('lastname') ? 'required' : '' }}</label>
		</div>
		</div>
		<div class="small-12 medium-6 columns right-field field-phone">
		<div class="field" :class="donation.phone ? 'has-content' : ''">
		    <input name="phone" type="tel" v-model="donation.phone" min="8" max="12" v-validate="'required'" :class="{'border-red': errors.has('phone')}" placeholder="Enter your phone" autocomplete="tel">
			<label for="phone">Phone {{ errors.first('phone') ? 'required' : '' }}</label>
		</div>
		</div>


		<div class="small-12 columns field-address"  v-if="!showFullAddress && !disabledGoogleAutocomplete">
		<div class="field has-content">
            <vue-google-autocomplete :id="dynamicId" :name="dynamicId" v-validate="'required'" :enable-geolocation="true" classname="form-control" :class="{'border-red': errors.has(dynamicId)}" placeholder="Please enter a location" v-on:placechanged="getAddressData" country="au"></vue-google-autocomplete>
            <label :for="dynamicId">Enter your address</label>
			<span class="wwf-alert-address"><p v-if="errors.first(dynamicId)">We cannot find your address. <a v-on:click="showFullAddress = true">Please click here to enter your address manually.</a></p><a v-if="!errors.first(dynamicId)" v-on:click="showFullAddress = true">If you don't live in Australia, please click here to enter your address manually.</a></span>       
		</div>
		</div>

<div class="small-12 columns small-collapse" v-if="showFullAddress || disabledGoogleAutocomplete">
		<div class="small-12 columns field-address-readonly" v-if="addressSelected">
		<div class="field has-content">
            <input name="addressSelected" type="text" v-model="addressSelected" readonly>
            <label :for="dynamicId">Your address</label>
		</div>
		</div>
        <div class="small-12 columns" v-if="!addressSelected">
        <h2>Enter your address</h2>
        </div>
		<div class="small-6 columns left-field">
		<div class="field" :class="donation.billing.unitnumber ? 'has-content' : 'unit-no-border'">
            <input name="unitnumber" type="tel" v-model="donation.billing.unitnumber" :class="{'border-red': errors.has('unitnumber')}" placeholder="Unit #">
			<label for="unitnumber">Unit number</label>
		</div>
		</div>
    <div class="small-6 columns right-field unit-no-alert-container">
		<div>
        <div class="unit-no-alert" :class="donation.billing.unitnumber ? 'fadeaway' : ''">
          <p>Please enter unit number if applicable</p>
        </div>
		</div>
		</div>
		<div class="small-6 columns left-field">
		<div class="field" :class="donation.billing.streetno ? 'has-content' : ''">
            <input name="streetno" type="text" v-model="donation.billing.streetno" v-validate="'required'" :class="{'border-red': errors.has('streetno')}" placeholder="Street #" autocomplete="no">
			<label for="streetno">Street number {{ errors.first('streetno') ? 'required' : '' }}</label>
		</div>
		</div>
		<div class="small-6 columns right-field">
		<div class="field" :class="donation.billing.streetname ? 'has-content' : ''">
            <input name="streetname" type="text" v-model="donation.billing.streetname" v-validate="'required'" :class="{'border-red': errors.has('streetname')}" placeholder="Street Name" autocomplete="address-line1">
			<label for="streetname">Street name {{ errors.first('streetname') ? 'required' : '' }}</label> 
		</div>
		</div>
		<div class="small-6 columns left-field">
            <div class="field" :class="donation.billing.postcode ? 'has-content' : ''">
                <input v-if="donation.billing.country == 'Australia'" name="postcode" type="tel" v-model="donation.billing.postcode" v-validate="'required'" :class="{'border-red': errors.has('postcode')}" placeholder="Postcode" maxlength="4" autocomplete="postal-code">
                <input v-if="donation.billing.country != 'Australia'" name="postcode" type="tel" v-model="donation.billing.postcode" v-validate="'required'" :class="{'border-red': errors.has('postcode')}" placeholder="Postcode" autocomplete="postal-code">

                <label for="postcode">Postcode {{ errors.first('postcode') ? 'required' : '' }}</label>
            </div>
		</div>
		<div class="small-6 columns right-field">
		<div class="field" :class="donation.billing.state ? 'has-content' : ''">
			<select v-if="donation.billing.country == 'Australia'" name="state" v-model="donation.billing.state" v-validate="'required'" :class="{'border-red': errors.has('state')}">
				<option value="" disabled selected>Select a state</option>
				<option value="NSW">NSW</option>
        <option value="ACT">ACT</option>
        <option value="NT">NT</option>
				<option value="SA">SA</option>
				<option value="WA">WA</option>
				<option value="VIC">VIC</option>
				<option value="QLD">QLD</option>
				<option value="TAS">TAS</option>
			</select>
            <input v-if="donation.billing.country != 'Australia'" name="state" type="text" v-model="donation.billing.state" :class="{'border-red': errors.has('state')}" placeholder="State">
			<label for="state">State {{ errors.first('state') ? 'required' : '' }}</label>
		</div>
		</div>
		<div  class="small-6 columns left-field">
		<div class="field" :class="donation.billing.suburb ? 'has-content' : ''">
            <input name="suburb" type="text" v-model="donation.billing.suburb" v-validate="'required'" :class="{'border-red': errors.has('suburb')}" placeholder="Suburb">
			<label for="suburb">Suburb {{ errors.first('suburb') ? 'required' : '' }}</label>
		</div>
		</div>
		<div  class="small-6 columns right-field end">
		<div class="field" :class="donation.billing.country ? 'has-content' : ''">

      <select name="country" v-model="donation.billing.country" v-validate="'required'" :class="{'border-red': errors.has('country')}" autocomplete="country">
          <option v-for="(countries, index) in countriesList" :value="countries.name">{{countries.name}}</option>
      </select>

			<label for="country">Country {{ errors.first('country') ? 'required' : '' }}</label>
		</div>
		</div>
		<div class="small-12 columns alert" v-show="donation.billing.country != 'Australia' && product.producttype == 'adoption'">
			<p>We're sorry, gifts and toy products can only be delivered within Australia.</p>
		</div>

</div>


            <div v-if="donation.isGift">

<div class="small-collapse">
 <div class="small-12 columns">
<h2>Enter recipients details</h2>
 </div> 
<div class="small-12 medium-6 columns left-field">
		<div class="field" :class="donation.gift.title ? 'has-content' : ''">
				 <select name="gift-title" v-model="donation.gift.title" v-validate="'required'" :class="{'border-red': errors.has('gift-title')}" placeholder="Title">
                        <option value="" disabled selected>Select a title</option>
                        <option value="Mr">Mr</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Ms">Ms</option>
                        <option value="Miss">Miss</option>
                    </select>
			<label for="gift-title">Title {{ errors.first('gift-title') ? 'required' : '' }}</label>
		</div>
		</div>

		<div class="small-12 medium-6 columns right-field">
		<div class="field" :class="donation.gift.firstname ? 'has-content' : ''">
            <input name="gift-firstname" type="text" v-model="donation.gift.firstname" v-validate="'required'" :class="{'border-red': errors.has('gift-firstname')}" placeholder="Enter the first name">
			<label for="gift-firstname">First name {{ errors.first('gift-firstname') ? 'required' : '' }}</label>
		</div>
		</div>
		<div class="small-12 columns">
		<div class="field" :class="donation.gift.lastname ? 'has-content' : ''">
            <input name="gift-lastname" type="text" v-model="donation.gift.lastname" v-validate="'required'" :class="{'border-red': errors.has('gift-lastname')}" placeholder="Enter your last name">
			<label for="gift-lastname">Last name {{ errors.first('gift-lastname') ? 'required' : '' }}</label>
		</div>
		</div>
</div>
        
		<div class="wwf-checkbox">
			<label>This gift is to be delivered to the same billing address
				<input type="checkbox" name="isSameAddress" v-model="donation.isSameAddress">
				<span class="checkbox"></span>
			</label>
		</div>

<div class="small-collapse" v-if="!donation.isSameAddress">

		<div class="small-12 columns" v-if="!showFullAddressGifts && !disabledGoogleAutocomplete">
			<div class="field has-content">
				<vue-google-autocomplete id="gift-map" name="gift-map"  v-validate="'required'" types="geocode" classname="form-control" :class="{'border-red': errors.has('gift-map')}" placeholder="Please enter a location" v-on:placechanged="getAddressDataGift" country="au"></vue-google-autocomplete>
				<label for="gift-map">Enter the address</label>
                <span class="wwf-alert-address"><p v-if="errors.first('gift-map')">We cannot find the address. <a v-on:click="showFullAddressGifts = true">Please click here to enter your address manually.</a></p>
                <a v-if="!errors.first('gift-map')" class="wwf-alert-address-href" v-on:click="showFullAddressGifts = true">If you don't live in Australia, please click here to enter your address manually.</a>
                </span> 
			</div>
		</div>

        <div class="row small-collapse" v-if="showFullAddressGifts || disabledGoogleAutocomplete">
		<div class="small-12 columns field-address-readonly" v-if="addressgiftSelected">
		<div class="field has-content">
            <input name="addressgiftSelected" type="text" v-model="addressgiftSelected" readonly>
            <label :for="addressgiftSelected">The recipients address</label>
		</div>
		</div>
        <div class="small-12 columns" v-if="!addressgiftSelected">
        <h2>Enter recipients address</h2>
        </div>

		<div class="small-6 columns left-field">
		<div class="field" :class="donation.gift.unitnumber ? 'has-content' : ''">
            <input name="gift-unitnumber" type="tel" v-model="donation.gift.unitnumber" :class="{'border-red': errors.has('gift-unitnumber')}" placeholder="Unit #">
			<label for="gift-unitnumber">Unit number</label>
		</div>
		</div>
		<div class="small-6 columns right-field">
		<div class="field" :class="donation.gift.streetno ? 'has-content' : ''">
            <input name="gift-streetno" type="text" v-model="donation.gift.streetno" v-validate="'required'" :class="{'border-red': errors.has('gift-streetno')}" placeholder="Street #" autocomplete="no">
			<label for="gift-streetno">Street number {{ errors.first('gift-streetno') ? 'required' : '' }}</label>
		</div>
		</div>
		<div class="small-6 columns left-field">
		<div class="field" :class="donation.gift.streetname ? 'has-content' : ''">
            <input name="gift-streetname" type="text" v-model="donation.gift.streetname" v-validate="'required'" :class="{'border-red': errors.has('gift-streetname')}" placeholder="Street Name">
			<label for="gift-streetname">Street name {{ errors.first('gift-streetname') ? 'required' : '' }}</label>
		</div>
		</div>
		<div class="small-6 columns right-field">
		<div class="field" :class="donation.gift.postcode ? 'has-content' : ''">
            <input  v-if="donation.gift.country == 'Australia'" name="gift-postcode" type="tel" v-model="donation.gift.postcode" v-validate="'required'" maxlength="4" :class="{'border-red': errors.has('gift-postcode')}" placeholder="Postcode">
            <input v-if="donation.gift.country != 'Australia'" name="gift-postcode" type="text" v-model="donation.gift.postcode"  v-validate="'required'" :class="{'border-red': errors.has('gift-postcode')}" placeholder="Postcode">

			<label for="gift-postcode">Postcode {{ errors.first('gift-postcode') ? 'required' : '' }}</label>
		</div>
		</div>
		<div class="small-6 columns left-field">
		<div class="field" :class="donation.gift.state ? 'has-content' : ''">
			<select v-if="donation.gift.country == 'Australia'" name="gift-state" v-model="donation.gift.state" v-validate="'required'" :class="{'border-red': errors.has('gift-state')}">
				<option value="" disabled selected>Select a state</option>
				<option value="NSW">NSW</option>
        <option value="ACT">ACT</option>
        <option value="NT">NT</option>
				<option value="SA">SA</option>
				<option value="WA">WA</option>
				<option value="VIC">VIC</option>
				<option value="QLD">QLD</option>
				<option value="TAS">TAS</option>
			</select>
            <input v-if="donation.gift.country != 'Australia'" name="gift-state" type="text" v-model="donation.gift.state" :class="{'border-red': errors.has('gift-state')}" placeholder="State">
			<label for="gift-state">State {{ errors.first('gift-state') ? 'required' : '' }}</label>
		</div>
		</div>
		<div  class="small-6 columns right-field">
		<div class="field" :class="donation.gift.suburb ? 'has-content' : ''">
            <input name="gift-suburb" type="text" v-model="donation.gift.suburb" v-validate="'required'" :class="{'border-red': errors.has('gift-suburb')}" placeholder="Suburb">
			<label for="gift-suburb">Suburb {{ errors.first('gift-suburb') ? 'required' : '' }}</label> 
		</div>
		</div>
		<div  class="small-6 columns left-field end">
		<div class="field" :class="donation.gift.country ? 'has-content' : ''">

    <select name="gift-country" v-model="donation.gift.country" v-validate="'required'" :class="{'border-red': errors.has('gift-country')}">
        <option v-for="(countries, index) in countriesList" :value="countries.name">{{countries.name}}</option>
    </select>
		
			<label for="gift-country">Country {{ errors.first('gift-country') ? 'required' : '' }}</label>
		</div>
		</div>
		<div class="small-12 columns alert" v-show="donation.gift.country != 'Australia' && product.producttype == 'adoption'">
			<p>We're sorry, gifts and toy products can only be delivered within Australia.</p>
		</div>
        </div>

</div>


            </div>

<div class="small-12 columns">
  <h2>Choose payment type</h2>
    <ul class="wwf-radio-bttns payment-type--radio">
      <li>
        <label><span class="cc-title">Credit card</span>
            <img src="/ecThemes/4/Images/cc-visa.svg" class="paymentType paymentType--visa">
            <img src="/ecThemes/4/Images/cc-mastercard.svg" class="paymentType paymentType--mc">
            <img src="/ecThemes/4/Images/cc-amex-alt.svg" class="paymentType paymentType--amex">
            <input type="radio" v-model="newPaymentType" name="paymentType" value="wwf_purchasetokenise" id="payementTypeCC" v-validate="'required'" data-vv-as="payment type">
            <span class="wwf-radio"></span>
        </label>
      </li>
      <li v-if="product.producttype != 'wildcard'">
        <label><span class="cc-title">Direct debit</span>
            <input type="radio" v-model="newPaymentType" name="paymentType" value="wwf_directdebit" id="payementTypeDD" v-validate="'required'" data-vv-as="payment type">
            <span class="wwf-radio"></span>
        </label>
      </li>
      <li v-if="donation.type == 'Single'">
        <label><span class="cc-title">PayPal</span>
            <img src="/ecThemes/4/Images/PayPal.png" class="paymentType paymentType--PayPal"/>
            <input type="radio" v-model="newPaymentType" name="paymentType" value="wwf_paypal" id="payementTypePP" v-validate="'required'" data-vv-as="payment type">
            <span class="wwf-radio"></span>
        </label>
      </li>
      <span class="wwf-alert"><p v-if="errors.first('paymentType')">{{errors.first('paymentType')}}</p></span>
    </ul>
</div>

        </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import Datepicker from "vuejs-datepicker";
import moment from "moment"
import {
  getNameByDonatiuonType,
  pushDatalayerCheckout,
  getCountriesList
} from "../../helpers";

import { mapState } from 'vuex'

export default {
  components: { VueGoogleAutocomplete, Datepicker },
  data() {
    return {
      addressSelected: null,
      addressgiftSelected: null,
      showFullAddress: false,
      showFullAddressGifts: false,
      countriesList: getCountriesList(),
      newPaymentType: "wwf_purchasetokenise",
      disabledFn: {
          customPredictor: function(date) {
            if (moment(new Date()).isAfter(date, 'day')) {
            return true;
          }
          }
      }
    };
  },
  computed: mapState({
    donation: state => state.donation.donation,
    product: state => state.product.product,
    packages: state => state.product.packagesProduct
  }),
  beforeMount() {
    this.dynamicId = "shh-" + Date.now().toString();
  },
  props: {
    disabledGoogleAutocomplete: {
      // Attribute for the version of the product
      type: Boolean,
      default: false
    }
  },
  methods: {
    getAddressData: function(addressData, placeResultData, id) {
      this.donation.billing.unitnumber = addressData.subpremise || null;
      this.donation.billing.streetno = addressData.street_number;
      this.donation.billing.streetname = addressData.route;
      this.donation.billing.postcode = addressData.postal_code;
      this.donation.billing.state = addressData.administrative_area_level_1;
      this.donation.billing.suburb = addressData.locality;
      this.donation.billing.country = addressData.country;
      this.addressSelected = placeResultData.formatted_address || null;
      this.showFullAddress = true;
    },
    getAddressDataGift: function(addressData, placeResultData, id) {
      this.donation.gift.unitnumber = addressData.subpremise || null;
      this.donation.gift.streetno = addressData.street_number;
      this.donation.gift.streetname = addressData.route;
      this.donation.gift.postcode = addressData.postal_code;
      this.donation.gift.state = addressData.administrative_area_level_1;
      this.donation.gift.suburb = addressData.locality;
      this.donation.gift.country = addressData.country;
      this.addressgiftSelected = placeResultData.formatted_address || null;
      this.showFullAddressGifts = true;
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then(result => {
          if (!result) {
            reject("The form on step2 product is invalid");
          } else {
            var hasPayementHasChanged = (this.newPaymentType != this.donation.payementType)

            if (hasPayementHasChanged) { // ?????
              this.donation.payementType = this.newPaymentType 
            }
          
            this.$store.dispatch("saveDonationStep2").then(
              response => {
                pushDatalayerCheckout(
                  this.product.productname,
                  this.product.id,
                  this.donation.amount,
                  this.product.producttype,
                  getNameByDonatiuonType(this.donation.type)
                );

                if (hasPayementHasChanged) {
                  this.$store.dispatch("checkout").then(
                    response => {
                      if (response.body.method == "redirect") {
                        window.location.href = response.body.url;
                      } else {
                        resolve();
                      }
                    },
                    error => {
                      console.error("checkout step 2", error);
                      reject(error);
                    }
                  );
                } else {
                  resolve();
                }
              },
              error => {
                console.error("saveDonation error", error);
                reject(error);
              }
            );
          }
        });
      });
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Step2.vue?cebe3e58